import CrmServiceCollection from "@/collections/CrmServiceCollection"
import CustomerFieldModel from "@/models/crm/CustomerFieldModel"

export default class CustomerFieldCollection extends CrmServiceCollection {
  model() {
    return CustomerFieldModel
  }
}